import { formatDateWithOptionsBs } from "@/lib/format";

export function formatDate(iso: string): string {
  return formatDateWithOptionsBs(iso, {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Europe/Sarajevo",
  });
}

export function formatDateShort(iso: string): string {
  return formatDateWithOptionsBs(iso, {
    day: "numeric",
    month: "short",
    timeZone: "Europe/Sarajevo",
  });
}

export function toLocalISODate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/**
 * Bosanska množina uz broj: 1 (i 21, 31...) → one, 2-4 (i 22-24...) → few,
 * ostalo (5+, 11-14) → other. Npr. "1 dospjela faktura", "2 dospjele fakture",
 * "5 dospjelih faktura".
 */
export function pluralBs(count: number, one: string, few: string, other: string): string {
  const mod10 = count % 10;
  const mod100 = count % 100;
  const form = mod10 === 1 && mod100 !== 11
    ? one
    : mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)
      ? few
      : other;
  return `${count} ${form}`;
}
